import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'intersection-observer';
import Observer from '@researchgate/react-intersection-observer';
  
class GiftGuideHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSticky: false
    };
    
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ isIntersecting, intersectionRatio }, unobserve) {
    if (!isIntersecting) {
      this.setState((state) => ({ ...state, isSticky: true }));
    } else {
      this.setState((state) => ({ ...state, isSticky: false }));
    }
  }

  render() {
    return (
      <div>
        <div
          className={`header active-header ${this.state.isSticky ? 'sticky' : ''}`}
          ref={this.element}
        >
          <div
            className={'header-background'}
            dangerouslySetInnerHTML={{ __html: this.props.headerBackgroundHTHML }}
          />
          <ul id={'filterOptions'}>
            {(this.props.desktop === true || this.props.menuExpanded) &&
            this.props.tags &&
            this.props.tags.map((tag) => (
              <li
                key={tag.value}
                className={
                  this.props.activeTags.find((activeTag) => activeTag.value === tag.value)
                    ? 'active' : ''
                }
              >
                <a
                  onClick={(_) =>
                    this.props.setActiveTag(
                      tag
                    )}
                >
                  <img src={tag.image} alt={tag.value} />
                  <h3>{tag.title}</h3>
                </a>
              </li>
            ))}
          </ul>
          {this.props.desktop === false && this.props.toggleTagsOnMobile && (
            <a className={'toggle'} onClick={this.props.toggleMenu}>
              {this.props.menuExpanded
                ? this.props.texts.closeCategories
                : this.props.texts.openCategories}
            </a>
          )}
        </div>
        <Observer onChange={this.handleChange} threshold={[0, 1]}>
          <div data-fake-header />
        </Observer>
      </div>
    );
  }
}

GiftGuideHeader.propTypes = {
  activeTag: PropTypes.shape({
    value: PropTypes.string
  }),
  activeTags: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string
    })
  ),
  headerBackgroundHTHML: PropTypes.string.isRequired,
  desktop: PropTypes.bool,
  menuExpanded: PropTypes.bool,
  toggleMenu: PropTypes.func,
  setActiveTag: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  texts: PropTypes.shape({
    closeCategories: PropTypes.string,
    openCategories: PropTypes.string
  }).isRequired,
  stickyHeader: PropTypes.bool,
  toggleTagsOnMobile: PropTypes.bool
};

GiftGuideHeader.defaultProps = {
  activeTag: { value: 'all' },
  activeTags: [{ value: 'all' }],
  desktop: true,
  menuExpanded: false,
  toggleMenu: () => {},
  stickyHeader: false,
  toggleTagsOnMobile: false
};

export default GiftGuideHeader;
